import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import { Icon } from '../ui/Icon';

export function WarningBanner() {
  return (
    <div
      className="warning-banner border-b border-white/10  backdrop-blur"
      role="region"
      aria-label="Avertissement jeu responsable"
    >
      <div className="lbf-container py-2">
        <p className="flex flex-wrap items-center justify-center gap-x-2  text-center text-[9px] font-semibold leading-snug text-zinc-200/90 sm:text-[10px]">
          <span className="inline-flex items-center gap-2">
            <Icon icon={FiAlertTriangle} aria-hidden="true" />
            JEUX D&apos;ARGENT ET DE HASARD PEUVENT ÊTRE DANGEREUX: PERTES D&apos;ARGENT, CONFLITS FAMILIAUX, ADDICTION.
          </span>
          <span className="text-zinc-300/80">RETROUVEZ NOS CONSEILS SUR</span>
          <a
            href="https://www.joueurs-info-service.fr/"
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-md border border-white/10 bg-white/5 px-2 py-1 text-[10px] font-extrabold tracking-wide text-white/90 transition hover:bg-white/10 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-fuchsia-400/70 sm:text-[11px]"
          >
            JOUEURS-INFO-SERVICE.FR
          </a>
          <span className="text-zinc-300/80">(09 74 75 13 13 - APPEL NON SURTAXÉ)</span>
        </p>
      </div>
    </div>
  );
}


